import * as types from "./mutations.types";
import { storage, http, urls, token } from "../../../services";

// eslint-disable-next-line no-unused-vars
export const actionSetUser = ({ commit, dispatch }, payload) => {
  dispatch("actionSetToken", storage.getLocalToken());
  commit(types.SET_USER, payload);
};

export const actionSetToken = ({ commit }, payload) => {
  /** Set Token in Header Axios */
  token({ token: payload });
  /** Set Token in Storage */

  storage.setLocalToken(payload);
  commit(types.SET_TOKEN, payload);
};

/**
 * Fazendo chamada http para servidor realizar login
 * @param { Abrange { commit, dispatch ... } } context
 * @param { Dados do usuario } payload
 */
export const actionLogin = ({ dispatch }, payload) => {
  return http
    .POST(urls.signin, payload)
    .then(response => {
      /** Set Token */
      let token = response.data.token;

      dispatch("actionSetToken", token);
    })
    .catch(error => {
      throw error.response.data;
    });
};

/**
 * Busca usuario e seta o mesmo no state
 * @param {*} param0
 * @param {*} payload
 * @param {*} state
 */
export const actionGetUser = ({ dispatch, state }) => {
  token({ token: storage.getLocalToken() });
  return http
    .GET(urls.me)
    .then(response => {
      dispatch("actionSetUser", response.data);
    })
    .catch(error => {
      state.error = error;
      throw error.response.data;
    });
};

export const actionCheckToken = ({ dispatch }) => {
  return dispatch("actionGetUser");
};

export const actionSingOut = ({ dispatch }) => {
  /** Set Token in Header Axios */
  token("");
  storage.deleteLocalToken();
  dispatch("actionSetUser", {});
  dispatch("actionSetToken", "");
};
